/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Contributor: Michael Shaffer <michael@hbrisk.com>
 * Date: 4/13/17
 * Copyright All Rights Reserved
 */

/*
* Use this module to set the runtime configs
*/

/*
* Constants for config keys
*/

export const API_HOST = 'apiHost';
export const API_PROTOCOL = 'apiProtocol';
export const GOOGLE_MAPS_API_KEY = 'googleMapsApiKey';
export const ENVIRONMENT = 'environment';
export const ROLLBAR_ACCESS_TOKEN = 'rollbarAccessToken';
export const ROLLBAR_ENABLED = 'rollbarEnabled';
export const REDUX_LOGGER_ENABLED = 'reduxLoggerEnabled';

/**
 * The default set of configuration values that the application should revert to when no other
 * values can be found. This gets overwritten by the values for the specific context.
 */

const appConfigs = {
  [API_HOST]: 'localhost:3000',
  [API_PROTOCOL]: 'http',
  [ENVIRONMENT]: 'development',
  [GOOGLE_MAPS_API_KEY]: 'AIzaSyAH1ncbQd7B4hKgUgvR_f5plHYkQJJHQ_Y',
  [ROLLBAR_ACCESS_TOKEN]: '6dd039cf56be44e5bb1ee7b70e6b9a59',
  [ROLLBAR_ENABLED]: process.env.NODE_ENV === 'production', // determined by Webpack build type
  [REDUX_LOGGER_ENABLED]: process.env.NODE_ENV !== 'production', // determined by Webpack build type
};

/**
 * Merge a provided set of configs with the list of default configs so that every environment only
 * has to specify the configs that it actually needs to be different from the defaults.
 */
function mergeDefaults(configs) {
  return Object.assign(appConfigs, configs);
}

/**
 * Returns a promise that resolves the app's configs based on the current host name
 *
 * @returns {Promise}
 */
const requestConfigs = () => new Promise(
  (resolve) => {
    switch (window.location.hostname) {
      case 'site-hazards.hbrisk.com':
        resolve(mergeDefaults({
          [API_HOST]: 'api.site-hazards.hbrisk.com',
          [API_PROTOCOL]: 'https',
          [ENVIRONMENT]: 'production',
        }));
        break;
      case 'staging.site-hazards.hbrisk.com':
        resolve(mergeDefaults({
          [API_HOST]: 'staging.api.site-hazards.hbrisk.com',
          [API_PROTOCOL]: 'https',
          [ENVIRONMENT]: 'staging',
        }));
        break;
      default:
        resolve(appConfigs);
        break;
    }
  });

export const initializeConfigs = () => requestConfigs().then(
  (configs) => {
    Object.keys(configs).forEach(
      (prop) => {
        appConfigs[prop] = configs[prop];
      }
    );
    return appConfigs;
  });

/**
 * Gets the config values and then attempts to find the given name attribute returning undefined if
 * not found.
 */
const config = name => appConfigs[name];

export default config;
